import { TransformType } from '@mr-yum/cdn-image'
import { ImageLoaderProps } from 'next/image'
import { cloudflareImageUrl } from 'utils/cloudflareImageUrl'

export const cloudflareLoader = ({
  loaderOptions,
  transform = TransformType.DEFAULT,
  hasError = false,
}: {
  loaderOptions: ImageLoaderProps
  transform?: TransformType
  hasError?: boolean
}) => {
  const { src } = loaderOptions

  if (hasError) {
    return src
  }

  return cloudflareImageUrl({ ...loaderOptions, transform })
}
